import { computed } from "nanostores";

import type { ListPollersData } from "../api/types.gen";

import { getPoller, listPollers, Options } from "../api";
import { createCursorPaginationStore } from "../stores/cursor-pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $pollersPagination = createCursorPaginationStore();

const $cursorParam = computed(
  $pollersPagination.$cursorParams,
  (cursor) => cursor ?? "",
);

export const $pollersList = createApiStore(listPollers, {
  mapToOptions: ([cursorParam]): Options<ListPollersData, false> => {
    return {
      query: {
        cursor: cursorParam || undefined,
        pageSize: 10,
      },
    };
  },
  params: [$cursorParam, computed($router, (route) => String(route?.route))],
  storeKey: "pollersList",
});

export const $pollerContent = createApiStore(getPoller, {
  mapToOptions: ([pollerId]) => ({
    path: { id: pollerId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "pollerId" in router.params ? router.params.pollerId : null;
    }),
  ],
  storeKey: "pollerContent",
});
